import BackOfficeAccounts from "./BackOfficeAccounts";
import WithLayout from "src/Components/Layout/Layout";

export default WithLayout(BackOfficeAccounts);